module.exports = __webpack_public_path__ + "static/media/logo-complet.4448b83d.png";